<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">{{$store.state.isIndividual ? 'Receipts' : 'Invoices'}}</h4>
        <div class="category">Past credit transactions processed by you {{$store.state.isIndividual ? '' : 'and your team'}}</div>
      </div>
      <div class="card-content row form-horizontal">
        <div class="col-sm-12">
          <el-table class="table table-striped table-no-bordered table-hover"
                    ref="historyTable"
                    :data="history"
                    v-loading="paging"
                    element-loading-spinner="qc-spinner"
                    style="width: 100%"
                    highlight-current-row
                    @current-change="showInvoice"
                    tooltip-effect="light">
            <el-table-column :width="170" label="Date & Time">
              <template slot-scope="props">
                <span>{{formatDate(props.row.created)}}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="75" :show-overflow-tooltip="true" label="Item">
              <template slot-scope="props">
                <span v-if="props.row.type == 'PSV'">{{props.row.name}}</span>
                <span v-else-if="props.row.type == 'AC'">{{props.row.name}}</span>
                <span v-else-if="$store.state.isIndividual == true"> Receipt: {{props.row.id}}</span>
                <span v-else>Credit Purchase: Invoice {{props.row.id}}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" :show-overflow-tooltip="true" label="User">
              <template slot-scope="props">
                <span>{{props.row.username}}</span>
              </template>
            </el-table-column>
            <el-table-column :width="130" :show-overflow-tooltip="true" label="Total Amount" align="right" header-align="right">
              <template slot-scope="props">
                <span v-if="props.row.type == 'PSV'">-{{formatMoney(props.row.paid)}}</span>
                <span v-else-if="props.row.type == 'AC'">-{{formatMoney(props.row.paid)}}</span>
                <span v-else>{{formatMoney(props.row.paid)}}</span>
                <span></span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import accounting from 'accounting'
  import moment from 'moment'
  import PPagination from 'src/components/Pagination.vue'

  accounting.settings.currency.symbol = "£";

  export default {
    name: 'credit-history',
    components: {
      PPagination
    },
    data () {
      return {
        history: null,
        paging: false,
        total: 0,
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        }
      }
    },
    mounted () {
      this.getHistory()
      this.$store.commit('resetUnseenInvoices')
    },
    activated () {
      this.getHistory()
      this.$store.commit('resetUnseenInvoices')
    },
    watch: {
      paginationCurrentPage (value) {
        this.getHistory()
      },
      paginationPerPag (value) {
        this.getHistory()
      }
    },
    computed: {
      paginationCurrentPage () {
        return this.pagination.currentPage
      },
      paginationPerPag () {
        return this.pagination.perPage
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      }
    },
    methods: {
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY HH:mm')
      },
      formatMoney(amount) {
        return accounting.formatMoney(amount)
      },
      getHistory () {
        this.paging = true
        this.history = []
        let historyRequest = {
          page: this.pagination.currentPage - 1
        }
        this.$api.getCreditHistory(historyRequest)
          .then(response => {
            this.history = response.data.content
            this.pagination.total = response.data.totalSize
            this.total = response.data.totalSize
            this.paging = false
          })
          .catch(error => {
            this.paging = false
          })
      },
      showInvoice (row, oldRow) {
        if(row) {
          if(row.type == 'PSV') {
            this.$router.push('/verification/history/' + row.receiptId)
          } else if(row.type == 'AC') {
            if(row.receiptId != null) {
              this.$router.push('/verification/history/' + row.receiptId)
            } else {
              this.$snotify.warning("Standalone accreditations cannot be viewed yet.", "Not implemented")
            }
          } else {
            this.$router.push('/credit/history/' + row.id)
          }
        }
      }
    }

  }
</script>